"use strict";
// AdGuard DNS API utility functions for ad blocking
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticateAdGuard = authenticateAdGuard;
exports.refreshAdGuardToken = refreshAdGuardToken;
exports.getAdGuardConfig = getAdGuardConfig;
exports.revokeAdGuardToken = revokeAdGuardToken;
exports.isAdGuardAvailable = isAdGuardAvailable;
exports.getValidAdGuardToken = getValidAdGuardToken;
exports.makeAdGuardRequest = makeAdGuardRequest;
exports.clearAdGuardConfig = clearAdGuardConfig;
exports.enableAdBlockingForDomain = enableAdBlockingForDomain;
var ADGUARD_API_BASE = 'https://api.adguard-dns.io';
var ADGUARD_STORAGE_KEY = 'adguard_dns_config';
/**
 * Authenticate with AdGuard DNS API
 * @param username - AdGuard account email
 * @param password - AdGuard account password
 * @param mfaToken - Two-factor authentication token (optional)
 * @returns AdGuard DNS configuration or null if authentication fails
 */
function authenticateAdGuard(username, password, mfaToken) {
    return __awaiter(this, void 0, Promise, function () {
        var formData, response, data, config, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    formData = new URLSearchParams();
                    formData.append('username', username);
                    formData.append('password', password);
                    if (mfaToken) {
                        formData.append('mfa_token', mfaToken);
                    }
                    return [4 /*yield*/, fetch("".concat(ADGUARD_API_BASE, "/oapi/v1/oauth_token"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: formData
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    config = {
                        access_token: data.access_token,
                        refresh_token: data.refresh_token,
                        expires_at: Date.now() + (data.expires_in * 1000)
                    };
                    // Store in localStorage
                    localStorage.setItem(ADGUARD_STORAGE_KEY, JSON.stringify(config));
                    return [2 /*return*/, config];
                case 3:
                    error_1 = _a.sent();
                    console.error('AdGuard authentication failed:', error_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Refresh AdGuard access token using refresh token
 * @param refreshToken - Refresh token from previous authentication
 * @returns New AdGuard DNS configuration or null if refresh fails
 */
function refreshAdGuardToken(refreshToken) {
    return __awaiter(this, void 0, Promise, function () {
        var formData, response, data, config, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    formData = new URLSearchParams();
                    formData.append('refresh_token', refreshToken);
                    return [4 /*yield*/, fetch("".concat(ADGUARD_API_BASE, "/oapi/v1/oauth_token"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: formData
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    config = {
                        access_token: data.access_token,
                        refresh_token: data.refresh_token,
                        expires_at: Date.now() + (data.expires_in * 1000)
                    };
                    // Update localStorage
                    localStorage.setItem(ADGUARD_STORAGE_KEY, JSON.stringify(config));
                    return [2 /*return*/, config];
                case 3:
                    error_2 = _a.sent();
                    console.error('AdGuard token refresh failed:', error_2);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Get stored AdGuard DNS configuration
 * @returns AdGuard DNS configuration or null if not found/expired
 */
function getAdGuardConfig() {
    try {
        var raw = localStorage.getItem(ADGUARD_STORAGE_KEY);
        if (!raw)
            return null;
        var config = JSON.parse(raw);
        // Check if token is expired (with 5 minute buffer)
        if (Date.now() >= config.expires_at - (5 * 60 * 1000)) {
            return null;
        }
        return config;
    }
    catch (_a) {
        return null;
    }
}
/**
 * Revoke AdGuard refresh token
 * @param refreshToken - Refresh token to revoke
 * @returns True if successful, false otherwise
 */
function revokeAdGuardToken(refreshToken) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat(ADGUARD_API_BASE, "/oapi/v1/revoke_token"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: "token=".concat(encodeURIComponent(refreshToken))
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
                    }
                    // Remove from localStorage
                    localStorage.removeItem(ADGUARD_STORAGE_KEY);
                    return [2 /*return*/, true];
                case 2:
                    error_3 = _a.sent();
                    console.error('AdGuard token revocation failed:', error_3);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Check if AdGuard DNS is available and authenticated
 * @returns True if AdGuard DNS is available, false otherwise
 */
function isAdGuardAvailable() {
    var config = getAdGuardConfig();
    return config !== null;
}
/**
 * Get valid access token for AdGuard API calls
 * @returns Valid access token or null if not available
 */
function getValidAdGuardToken() {
    return __awaiter(this, void 0, Promise, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = getAdGuardConfig();
                    if (!config) {
                        return [2 /*return*/, null];
                    }
                    if (!(Date.now() >= config.expires_at - (5 * 60 * 1000))) return [3 /*break*/, 2];
                    return [4 /*yield*/, refreshAdGuardToken(config.refresh_token)];
                case 1:
                    config = _a.sent();
                    if (!config) {
                        return [2 /*return*/, null];
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, config.access_token];
            }
        });
    });
}
/**
 * Make authenticated request to AdGuard API
 * @param endpoint - API endpoint (without base URL)
 * @param options - Fetch options
 * @returns Response or null if authentication fails
 */
function makeAdGuardRequest(endpoint_1) {
    return __awaiter(this, arguments, Promise, function (endpoint, options) {
        var token, url, headers, error_4;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getValidAdGuardToken()];
                case 1:
                    token = _a.sent();
                    if (!token) {
                        return [2 /*return*/, null];
                    }
                    url = "".concat(ADGUARD_API_BASE).concat(endpoint);
                    headers = __assign({ 'Authorization': "Bearer ".concat(token), 'Content-Type': 'application/json' }, options.headers);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { headers: headers }))];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    error_4 = _a.sent();
                    console.error('AdGuard API request failed:', error_4);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Clear stored AdGuard configuration
 */
function clearAdGuardConfig() {
    localStorage.removeItem(ADGUARD_STORAGE_KEY);
}
/**
 * Example usage of AdGuard DNS API for ad blocking
 * This function can be called to enable ad blocking for specific domains
 */
function enableAdBlockingForDomain(domain) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, makeAdGuardRequest('/api/v1/filtering/status')];
                case 1:
                    response = _a.sent();
                    if (response && response.ok) {
                        console.log("Ad blocking enabled for ".concat(domain));
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 2:
                    error_5 = _a.sent();
                    console.error('Failed to enable ad blocking:', error_5);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
